import { z } from 'zod';

export const TenantMfaChannelSchema = z.enum(['email', 'sms']);

const objectId = z.string().regex(/^[a-f\d]{24}$/i, 'Invalid id');
const nullableObjectId = objectId.nullable().optional();

export const UpdateTenantMfaSettingsSchema = z.object({
    emailEnabled: z.boolean(),
    smsEnabled: z.boolean(),
    defaultEmailProviderId: nullableObjectId,
    defaultSmsProviderId: nullableObjectId,
}).superRefine((data, ctx) => {
    if (data.emailEnabled && !data.defaultEmailProviderId) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Default email provider is required when email MFA is enabled',
            path: ['defaultEmailProviderId'],
        });
    }
    if (data.smsEnabled && !data.defaultSmsProviderId) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Default SMS provider is required when SMS MFA is enabled',
            path: ['defaultSmsProviderId'],
        });
    }
});

export const TenantSwitchEvaluateSchema = z.object({
    targetTenantId: z.string().min(1),
});

export const TenantSwitchVerifySchema = z.object({
    challengeId: z.string().min(1),
    code: z.string().min(4).max(8),
    channel: TenantMfaChannelSchema.optional(),
});
